var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"primary button-icon",attrs:{"icon":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon,"color":"white","size":_vm.iconSize}}):_vm._e(),(_vm.vIcon)?_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v(_vm._s(_vm.vIcon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }